import { NavAction } from '@/components/nav/EntityLink';
import { toMembers, toTenantSettings } from '@/lib/nav';

/**
 * 売上単価が未設定のプロジェクトがあるときの案内。
 *
 * 行ごとにリンクを繰り返さない。直しに行く先は全行同じで、表を狭く保ちたいため
 * (列が 10 本あり、幅の取り合いになっている)。
 *
 * 売上単価の在り処は 2 つ (その人の単価 → 組織の既定単価) なので飛び先も 2 つ。
 * `NavAction` は開けない人には何も出さないので、admin でない人には
 * メンバー画面へのリンクが出ない (押した先でリダイレクトされるリンクを見せない)。
 */
export function RateNotice({ count }: { count: number }) {
  if (count === 0) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border border-alert bg-surface-raised px-4 py-3">
      <span className="text-sm text-ink">
        {`売上単価が設定されていないため、想定売上と粗利を出せないプロジェクトが ${count} 件あります。`}
      </span>
      <span className="flex items-center gap-2">
        <NavAction target={toMembers()} />
        <NavAction target={toTenantSettings()} />
      </span>
    </div>
  );
}
